import * as S from "./style";
import * as C from "../base/style";
import { useTournamentContext } from "../../../../hook/context";
import { EditTournamentBaseContent } from "../base/style/index";
import {
  EditTournamentCheckBox,
  EditTournamentCheckBoxWrapper,
} from "../../style";

const EditTournamentStructure = () => {
  const {
    structures,
    handleInputChange,
    handleChangeToBreak,
    handleChangeToLevel,
    handleAddLevel,
    handleAddBreak,
    handleDelete,
    handleMoveUp,
    handleMoveDown,
    handleMoveTop,
    handleMoveBottom,
    handleStructureList,
    structureCheckList,
  } = useTournamentContext();

  const headers = [
    { header: "", name: "z" },
    { header: "LV", name: "a" },
    { header: "시간", name: "c" },
    { header: "SB", name: "d" },
    { header: "BB", name: "d" },
    { header: "ANTE", name: "d" },
    { header: "칩 제거", name: "d" },
  ];

  const headerButtons = [
    { type: "bottom", click: handleMoveBottom },
    { type: "down", click: handleMoveDown },
    { type: "top", click: handleMoveTop },
    { type: "up", click: handleMoveUp },
  ];

  return (
    <C.EditTournamentBaseWrapper>
      <C.EditTournamentBaseContent>
        <S.EditStructureHeaderButtonWrapper>
          <div className="button purple" onClick={() => handleAddLevel()}>
            <img src="/image-web/edit/plus.svg" alt="plus" />
            LEVEL 추가
          </div>
          <div className="button" onClick={() => handleAddBreak()}>
            <img src="/image-web/edit/plus-black.svg" alt="plus" />
            BREAK 추가
          </div>
        </S.EditStructureHeaderButtonWrapper>
      </C.EditTournamentBaseContent>
      <S.EditStructureMoveButtonWrapper>
        {headerButtons.map((b, i) => (
          <img
            key={i}
            onClick={() => b.click(structureCheckList)}
            src={`/image-web/edit/${b.type}.svg`}
            alt={b.type}
          />
        ))}
      </S.EditStructureMoveButtonWrapper>

      {structures.map((item, index) => (
        <C.EditTournamentBaseContent>
          <S.EditStructureItemHeader>
            <EditTournamentCheckBoxWrapper>
              <EditTournamentCheckBox isMobile={true}>
                <input
                  type="checkbox"
                  checked={structureCheckList.includes(index)}
                  onChange={() => handleStructureList(index)}
                />
                {structureCheckList.includes(index) && (
                  <img
                    src="/image-web/tournament/checked-icon.svg"
                    alt="checked"
                  />
                )}
              </EditTournamentCheckBox>
              <div className={item.type === "LEVEL" ? "level" : "break"}>
                {item.type === "LEVEL" ? `${item.level} LV` : "BREAK"}
              </div>
            </EditTournamentCheckBoxWrapper>
            <img
              src="/image-web/edit/trash-can.svg"
              alt="trash-can"
              onClick={() => handleDelete(index)}
            />
          </S.EditStructureItemHeader>

          <C.EditTournamentInputWrapper>
            {item.type === "LEVEL" ? (
              <>
                <C.EditTournamentInputBoxWrapper>
                  <C.EditTournamentInputBox>
                    <div className="name">SB</div>
                    <input
                      type="text"
                      value={
                        item.smallBlind ? item.smallBlind.toLocaleString() : 0
                      }
                      onChange={(e) =>
                        handleInputChange(e, index, "smallBlind")
                      }
                      inputMode="numeric"
                    />
                  </C.EditTournamentInputBox>
                  <C.EditTournamentInputBox>
                    <div className="name">BB</div>
                    <input
                      type="text"
                      value={item.bigBlind ? item.bigBlind.toLocaleString() : 0}
                      onChange={(e) => handleInputChange(e, index, "bigBlind")}
                      inputMode="numeric"
                    />
                  </C.EditTournamentInputBox>
                </C.EditTournamentInputBoxWrapper>
                <C.EditTournamentInputBoxWrapper>
                  <C.EditTournamentInputBox>
                    <div className="name">ANTE</div>
                    <input
                      type="text"
                      value={item.ante ? item.ante.toLocaleString() : 0}
                      onChange={(e) => handleInputChange(e, index, "ante")}
                      inputMode="numeric"
                    />
                  </C.EditTournamentInputBox>
                  <C.EditTournamentInputBox>
                    <div className="name">시간</div>
                    <input
                      type="text"
                      value={item.time ? item.time.toLocaleString() : 0}
                      onChange={(e) => handleInputChange(e, index, "time")}
                      inputMode="numeric"
                    />
                  </C.EditTournamentInputBox>
                </C.EditTournamentInputBoxWrapper>
              </>
            ) : (
              <C.EditTournamentInputBoxWrapper>
                <C.EditTournamentInputBox>
                  <div className="name">칩 제거</div>
                  <input
                    className="data"
                    type="text"
                    value={item.removeChip}
                    onChange={(e) => handleInputChange(e, index, "removeChip")}
                    inputMode="numeric"
                  />
                </C.EditTournamentInputBox>

                <C.EditTournamentInputBox>
                  <div className="name">시간</div>
                  <input
                    type="text"
                    value={item.time ? item.time.toLocaleString() : 0}
                    onChange={(e) => handleInputChange(e, index, "time")}
                    inputMode="numeric"
                  />
                </C.EditTournamentInputBox>
              </C.EditTournamentInputBoxWrapper>
            )}

            <S.EditStructureButton
              $isLevel={item.type === "LEVEL"}
              onClick={() =>
                item.type === "LEVEL"
                  ? handleChangeToBreak(index)
                  : handleChangeToLevel(index)
              }
            >
              {item.type === "LEVEL" ? "BREAK 전환" : "LEVEL 전환"}
            </S.EditStructureButton>
          </C.EditTournamentInputWrapper>
        </C.EditTournamentBaseContent>
      ))}
    </C.EditTournamentBaseWrapper>
  );
};

export default EditTournamentStructure;
